module.exports = __webpack_public_path__ + "static/media/maersk-logo.532f49e2.svg";